import { connect } from 'react-redux';
import { IState } from '../../store';
import { Dispatch } from 'redux';
import { HiddenBlockButtons, IHiddenBlockStoreButtonsProps, IHiddenBlockDispatchButtonsProps } from './';
import { toggleComplainPopup, restoreOffer } from '../../store/hide_offer';
import {
  ERestoreEventSource,
  selectProductsParams,
  trackHiddenObjects,
  EHideOfferAnalyticsCategory,
} from '../../tracking/hide_offer';

export const HiddenBlockButtonsContainer = connect(
  (state: IState): IHiddenBlockStoreButtonsProps => ({
    isComplainOpened: state.hideOffer.isComplainOpened,
    productParams: selectProductsParams(state),
  }),
  (dispatch: Dispatch<IState>): IHiddenBlockDispatchButtonsProps => ({
    toggleComplainPopup: (isOpened: boolean) => () => dispatch(toggleComplainPopup(isOpened)),
    restoreOffer: () => dispatch(restoreOffer(ERestoreEventSource.BUTTON)),
  }),
  (store: IHiddenBlockStoreButtonsProps, actions: IHiddenBlockDispatchButtonsProps, {}) => ({
    ...store,
    ...actions,
    toggleComplainPopup: (isOpened: boolean) => () => {
      if (isOpened) {
        trackHiddenObjects({
          action: 'Click_complain',
          category: EHideOfferAnalyticsCategory.HIDE,
          productParams: store.productParams,
        });
      }
      actions.toggleComplainPopup(isOpened)();
    },
  }),
)(HiddenBlockButtons);
